<ui-detail-section [title]="title()">
    <ui-detail-description
        [title]="'Name'"
        [htmlDescription]="name()"
    />

    @if (contact().email; as email) {
        <ui-detail-email-link
            [title]="'E-Mail'"
            [email]="email"
        />
    }

    @if (contact().phone; as phone) {
        <ui-detail-phone-link
            [title]="'Telefon'"
            [phone]="phone"
        />
    }
</ui-detail-section>
